const WheelLoader = () => (
  <div className="wheel-loader-container">
    <img
      src="/loader-wheel.png"
      alt="Cargando..."
      className="wheel-loader"
    />
  </div>
);

export default WheelLoader;
